export function redirectTo(url: string): void {
  window.location.href = url;
}
